// extracted by mini-css-extract-plugin
export default {"start":"StartScreen_start__xB2rf"};